import { Link } from 'react-router-dom';
import { Logo } from '../componentes/Logo';

const RECURSOS = [
  {
    titulo: 'O agente leva sozinho',
    texto:
      'Um programinha fica na máquina onde o sistema emite e vigia as pastas. Não muda nada no que já existe, '
      + 'não pede padrão de nome, não mexe em arquivo nenhum — lê o conteúdo do XML e entende o que é.',
  },
  {
    titulo: 'Guarda pelo prazo do escritório',
    texto:
      'XML e PDF ficam guardados pelo prazo que o contador definir (o padrão é 60 meses). '
      + 'Quando o prazo vence, o portal avisa com antecedência e oferece o pacote — apagar é decisão de alguém, nunca automático.',
  },
  {
    titulo: 'Relatório sai do portal',
    texto:
      'Totais por dia, por CFOP e por entrada/saída, montados a partir do XML que chegou — '
      + 'não do que alguém digitou depois. Inclusive nas notas de entrada.',
  },
  {
    titulo: 'A conferência é do portal',
    texto:
      'Numeração que pulou, documento sem XML, evento sem nota, competência sem envio. '
      + 'O portal aponta a divergência antes de você descobrir no fechamento.',
  },
  {
    titulo: 'Cada um vê o que é seu',
    texto:
      'O contador vê as empresas do escritório. O cliente vê as dele. '
      + 'O acesso fica no escritório, não na pessoa — funcionário entra e sai sem ninguém remexer vínculo de empresa.',
  },
  {
    titulo: 'Entra pelo WhatsApp',
    texto:
      'Sem senha para criar, esquecer, anotar num papel ou compartilhar com o escritório inteiro. '
      + 'O código chega no celular de quem está entrando.',
  },
];

const PASSOS = [
  {
    titulo: 'Instala uma vez',
    texto:
      'Na máquina onde o sistema emite. O instalador pergunta as pastas, testa a conexão na hora e sobe o serviço. '
      + 'Depois disso ninguém precisa lembrar que ele existe.',
  },
  {
    titulo: 'A primeira carga sobe o histórico',
    texto:
      'Os últimos cinco anos que estiverem nas pastas — a mesma janela que o portal guarda. '
      + 'Depois é só o que for emitindo, em lotes, sem duplicar nada.',
  },
  {
    titulo: 'O contador abre e está lá',
    texto:
      'Sem pedir, sem cobrar, sem esperar o dia 5. Se faltar alguma coisa, quem aponta é o portal — '
      + 'e a softhouse entra para corrigir só quando é chamada.',
  },
];

const HOJE = [
  '“Me manda os XML de julho” — todo mês, para cada cliente.',
  'Pendrive, e-mail, WhatsApp, pasta compartilhada que ninguém sabe quem apagou.',
  'Arquivo que chegou pela metade e só aparece no fechamento.',
  'Cinco anos de guarda que, no fundo, dependem de um HD que ninguém testou.',
];

export function Landing() {
  return (
    <div className="lp">
      <header className="lp-nav">
        <Logo tamanho={34} tamanhoFonte={23} />
        <nav className="lp-nav-links">
          <a href="#como">Como funciona</a>
          <a href="#recursos">O que faz</a>
          <a href="#seguranca">Guarda e acesso</a>
          <Link to="/entrar" className="btn btn-primary btn-sm">Entrar</Link>
        </nav>
      </header>

      {/* ── Hero ─────────────────────────────────────────────── */}
      <section className="lp-hero">
        <div className="lp-hero-copy fade-up">
          <div className="pill"><span className="dot" /> Guarda e distribuição de documentos fiscais</div>
          <h1 className="lp-h1">
            O XML sai do seu sistema e chega ao contador <span className="lp-accent">sozinho</span>.
          </h1>
          <p className="lp-sub">
            Sem pedir, sem pendrive, sem “me manda os arquivos de julho”. Um agente vigia a pasta onde o
            seu sistema já grava, leva tudo para o Conti9, e o escritório encontra o mês inteiro
            organizado — com o que faltou apontado antes do fechamento.
          </p>
          <div className="lp-hero-cta">
            <Link to="/entrar" className="btn btn-primary lp-cta-btn">Entrar no portal</Link>
            <a href="#como" className="btn btn-secondary lp-cta-btn">Ver como funciona</a>
          </div>
          <div className="lp-trust">
            <span>✓ Não muda nada no seu sistema atual</span>
            <span>✓ Traz os 5 anos de histórico</span>
            <span>✓ Nunca mexe nos seus arquivos</span>
          </div>
        </div>

        <div className="lp-hero-visual fade-up" aria-hidden="true">
          <div className="lp-fluxo">
            <div className="lp-fluxo-item">
              <div className="lp-fluxo-tag">na sua máquina</div>
              <div className="lp-pasta">
                <span className="lp-pasta-nome">C:\Sistema\NFe</span>
                <span className="lp-arq">26260…689901-nfe.xml</span>
                <span className="lp-arq">26260…690115-nfe.xml</span>
                <span className="lp-arq lp-arq-novo">26260…690238-nfe.xml</span>
              </div>
            </div>

            <div className="lp-fluxo-seta">
              <span className="lp-agente">agente</span>
              <svg viewBox="0 0 120 24" className="lp-seta">
                <path d="M2 12h104" />
                <path d="M100 6l8 6-8 6" />
              </svg>
            </div>

            <div className="lp-fluxo-item">
              <div className="lp-fluxo-tag">no escritório</div>
              <div className="lp-painel">
                <div className="lp-painel-linha lp-painel-cabecalho">
                  <span>Comércio Vale Verde</span>
                  <span className="selo ok">Em dia</span>
                </div>
                <div className="lp-painel-linha"><span>Notas de saída</span><strong>1.284</strong></div>
                <div className="lp-painel-linha"><span>Notas de entrada</span><strong>317</strong></div>
                <div className="lp-painel-linha"><span>Eventos</span><strong>46</strong></div>
                <div className="lp-painel-linha lp-painel-alerta">
                  <span>Numeração 4471 → 4473</span>
                  <span className="selo atencao">Divergência</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── O problema ───────────────────────────────────────── */}
      <section className="lp-section lp-section-alt">
        <div className="lp-dois">
          <div>
            <div className="pill"><span className="dot" /> O de sempre</div>
            <h2 className="lp-h2">Todo mês, a mesma caça aos arquivos</h2>
            <p className="lp-section-sub" style={{ margin: '0 0 22px' }}>
              O documento fiscal já nasceu eletrônico. O que continua manual é o caminho entre quem emite
              e quem escritura.
            </p>
            <ul className="lp-lista-x">
              {HOJE.map((t) => <li key={t}><span>×</span>{t}</li>)}
            </ul>
          </div>
          <div className="lp-quote">
            <p>
              O sistema já grava o XML numa pasta. O contador já sabe o que precisa.
              <strong> O que falta é o caminho entre os dois.</strong>
            </p>
            <span>É só isso que o Conti9 faz — e faz sem pedir nada a ninguém.</span>
          </div>
        </div>
      </section>

      {/* ── Como funciona ────────────────────────────────────── */}
      <section id="como" className="lp-section">
        <div className="lp-section-head">
          <div className="pill"><span className="dot" /> Como funciona</div>
          <h2 className="lp-h2">Três passos, e só o primeiro é seu</h2>
        </div>
        <div className="lp-passos">
          {PASSOS.map((p, i) => (
            <div key={p.titulo} className="lp-passo">
              <div className="lp-passo-num">{i + 1}</div>
              <h3>{p.titulo}</h3>
              <p>{p.texto}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Recursos ─────────────────────────────────────────── */}
      <section id="recursos" className="lp-section lp-section-alt">
        <div className="lp-section-head">
          <div className="pill"><span className="dot" /> O que faz</div>
          <h2 className="lp-h2">Guarda, distribui e confere</h2>
          <p className="lp-section-sub">
            O portal não recebe conferência pronta: ele mesmo calcula em cima do XML que chegou.
            É a diferença entre arquivar e responder.
          </p>
        </div>
        <div className="lp-grade">
          {RECURSOS.map((r) => (
            <div key={r.titulo} className="lp-card">
              <h3>{r.titulo}</h3>
              <p>{r.texto}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Dois lados ───────────────────────────────────────── */}
      <section className="lp-section">
        <div className="lp-section-head">
          <div className="pill"><span className="dot" /> Para quem é</div>
          <h2 className="lp-h2">Um portal, dois pontos de vista</h2>
        </div>
        <div className="lp-dois lp-dois-cards">
          <div className="lp-card lp-card-destaque">
            <div className="lp-card-etiqueta">Para o escritório contábil</div>
            <h3>As empresas do escritório, num lugar só</h3>
            <ul className="lp-lista-check">
              <li>Todo mundo que você atende, com o mês fechado ou aberto à vista.</li>
              <li>Totais por dia, por CFOP e por entrada/saída, prontos.</li>
              <li>O que faltou, apontado — não descoberto.</li>
              <li>Rotatividade de funcionário não mexe em acesso de empresa.</li>
            </ul>
          </div>
          <div className="lp-card lp-card-destaque">
            <div className="lp-card-etiqueta">Para quem emite</div>
            <h3>Você não manda mais nada</h3>
            <ul className="lp-lista-check">
              <li>Instala uma vez e esquece: o agente cuida do resto.</li>
              <li>Suas notas guardadas pelo prazo legal, fora da sua máquina.</li>
              <li>Baixa o XML de qualquer nota, de qualquer mês, quando precisar.</li>
              <li>Se o contador reclamar de algo, dá para ver o que ele está vendo.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ── Segurança ────────────────────────────────────────── */}
      <section id="seguranca" className="lp-section lp-section-alt">
        <div className="lp-section-head">
          <div className="pill"><span className="dot" /> Guarda e acesso</div>
          <h2 className="lp-h2">Documento fiscal de terceiro pede cuidado de terceiro</h2>
        </div>
        <div className="lp-grade lp-grade-3">
          <div className="lp-card">
            <h3>O agente nunca escreve na sua pasta</h3>
            <p>
              Ele lê e leva. Não move, não renomeia, não apaga — a pasta é do seu sistema, e mexer nela
              seria mexer na sua contabilidade. O controle do que já foi enviado fica do lado dele.
            </p>
          </div>
          <div className="lp-card">
            <h3>Apagar é ação confirmada</h3>
            <p>
              Vencido o prazo de guarda, o portal avisa com antecedência e oferece o download completo.
              Empresa em fiscalização pode ser travada — o prazo vence e nada é apagado.
            </p>
          </div>
          <div className="lp-card">
            <h3>Suporte entra por chamado</h3>
            <p>
              A softhouse não passeia pelos seus documentos: o acesso é temporário, aberto por um chamado
              e registrado. Quem viu o quê fica escrito.
            </p>
          </div>
        </div>
      </section>

      {/* ── Fechamento ───────────────────────────────────────── */}
      <section className="lp-cta">
        <h2>Pare de pedir arquivo.</h2>
        <p>
          Quem já é cliente entra com o celular — o código chega no WhatsApp, sem senha para lembrar.
        </p>
        <Link to="/entrar" className="btn btn-primary lp-cta-btn">Entrar no portal</Link>
      </section>

      <footer className="lp-rodape">
        <Logo tamanho={28} tamanhoFonte={18} />
        <span>Conti9 — guarda e distribuição de documentos fiscais eletrônicos.</span>
        <span className="lp-rodape-marca">um produto <strong>Grupo Atendi9</strong></span>
      </footer>
    </div>
  );
}
